import { Time } from "./Time";

export class Score {
  count = 0;
  start = Date.now();
  end = 0;
  highscore = 0;

  constructor() {
    this.load();
  }

  get time() {
    const delta = (this.end || Date.now()) - this.start;
    return new Time(delta);
  }

  save() {
    this.end = Date.now();
    if (this.count > this.highscore) {
      localStorage.setItem("highscore", this.count.toString());
      this.load();
    }
  }

  load() {
    const highscore = localStorage.getItem("highscore");
    if (highscore) this.highscore = Number(highscore);
  }
}
